"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScoreSystem = (function () {
    function ScoreSystem(options) {
        this.key = options.key || 'undefined';
        this.name = options.name || 'undefined';
        this.schema = options.schema || {};
        this.round = options.round;
        this.routes = options.routes;
        this.sortScoresBySummatedFunction = this.sortScoresBySummatedFunction.bind(this);
        this.sortScoresFunction = this.sortScoresFunction.bind(this);
        this.setScoresRank = this.setScoresRank.bind(this);
    }
    ScoreSystem.prototype.sortScoresFunction = function (aJoin, bJoin) {
        var a = aJoin.score;
        var b = bJoin.score;
        if (!a || !b) {
            return 0;
        }
        if (a.rank !== b.rank) {
            return a.rank - b.rank;
        }
        var index = this.sortScoresBySummatedFunction(a, b);
        if (index !== 0) {
            return index;
        }
        if (a.bibNumber && b.bibNumber) {
            return a.bibNumber - b.bibNumber;
        }
        if (aJoin.team && bJoin.team) {
            return aJoin.team.name.localeCompare(bJoin.team.name);
        }
        return 0;
    };
    ScoreSystem.prototype.setScoresRank = function (sortedScoreJoins) {
        var _this = this;
        if (sortedScoreJoins.length === 0) {
            return sortedScoreJoins;
        }
        var lastEqual = sortedScoreJoins[0];
        lastEqual.rank = 1;
        var rankedScoreJoins = sortedScoreJoins.map(function (s, i) {
            if (_this.sortScoresBySummatedFunction(s.score, lastEqual.score)) {
                s.rank = i + 1;
                lastEqual = s;
            }
            else {
                s.rank = lastEqual.rank;
            }
            return s;
        });
        return rankedScoreJoins;
    };
    ScoreSystem.prototype.generateDisplayString = function (score, isSummated) {
        if (isSummated === void 0) { isSummated = true; }
        return isSummated
            ? this.generateDisplayForSummated(score)
            : this.generateDisplayForCalculated(score);
    };
    ScoreSystem.prototype.sort = function (scoreJoins) {
        var sortedScoreJoins = scoreJoins.sort(this.sortScoresFunction);
        return this.setScoresRank(sortedScoreJoins);
    };
    return ScoreSystem;
}());
exports.default = ScoreSystem;
//# sourceMappingURL=ScoreSystem.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/ScoreSystem.js
// module id = 59
// module chunks = 0